var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-row",
    [
      _c(
        "v-col",
        {
          attrs: {
            cols: "12",
            md: "6"
          }
        },
        [
          _c(
            "gg-card-title",
            {
              staticClass: "pb-0 pt-0"
            },
            [_vm._v("Manage Your Websites")]
          )
        ],
        1
      ),
      _c(
        "v-col",
        {
          attrs: {
            cols: "12"
          }
        },
        [
          _c("WebsitesGroupController", {
            attrs: {
              collapsed: _vm.collapsedAll,
              title: "My Websites",
              "websites-count": _vm.filteredWebsites.length
            },
            on: {
              "collapse-all": _vm.handleCollapseAll,
              search: _vm.handleSearch
            },
            scopedSlots: _vm._u([
              {
                key: "filter",
                fn: function fn() {
                  return [
                    _c("g-g-filter", {
                      attrs: {
                        "offset-y": "",
                        left: "",
                        bottom: "",
                        "close-on-content-click": false,
                        items: _vm.filterItems
                      },
                      on: {
                        change: function change($event) {
                          _vm.filters = $event
                        }
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "button-prepend",
                          fn: function fn() {
                            return [
                              _c(
                                "v-icon",
                                {
                                  attrs: {
                                    size: "18"
                                  }
                                },
                                [_vm._v("mdi-filter-outline")]
                              )
                            ]
                          },
                          proxy: true
                        }
                      ])
                    })
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      ),
      _vm._l(_vm.filteredGroupedWebsites, function(group) {
        return _c(
          "v-col",
          {
            key: group.key,
            attrs: {
              cols: "12"
            }
          },
          [
            _c("WebsitesGroupTable", {
              attrs: {
                items: group.items,
                "group-name": group.name,
                "service-id": group.serviceId,
                "is-active": group.status === "Active",
                collapsed: _vm.getGroupCollapsed(group.key)
              },
              on: {
                collapse: function collapse($event) {
                  return _vm.handleGroupCollapse(group.key)
                }
              }
            })
          ],
          1
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }